import styled, { css, keyframes } from 'styled-components'

import { OutletCard } from '@src/components/SingleOutlet/OutletCard'
import { breakpoints } from '@src/constants/breakpoints'
import { between } from '@src/utils/breakpoints'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const OutletWrapper = styled.div<{ showAppBanner: boolean }>`
  padding-top: ${({ showAppBanner }) => (showAppBanner ? '184px' : '124px')};

  @media (min-width: ${breakpoints.largeTablet}px) {
    padding-top: 144px;
  }
`

export const AnimatedSection = styled.div<{
  $isVisible: boolean
}>`
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transform: translateY(0);
  transition: all 0.3s ease-in-out;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      animation: ${fadeIn} 0.3s ease-in-out forwards;
    `}
`

export const OutletListContainer = styled.div<{ isSearchResults?: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 0px;
  padding: 0 12px;
  margin-bottom: 0px;
  width: ${({ isSearchResults }) => isSearchResults && '100%'};
  background-color: ${({ theme }) => theme.colors.brandForeground};

  border-top: 1px solid ${({ theme }) => theme.colors.grey};
  margin-top: 8px;

  @media (min-width: ${breakpoints.tablet}px) {
    margin: 16px 0px 24px 16px;
    background-color: transparent;
    border: none;
  }
`

export const OutletListWithCategorySideMenuContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 32px;
  padding: 0 16px;
`

export const StyledOutletCard = styled(OutletCard)<{
  $showingCategorySideMenu: boolean
}>`
  width: 100%;

  @media (max-width: ${breakpoints.wideDesktop}px) {
    ${({ $showingCategorySideMenu }) =>
      between({
        start: $showingCategorySideMenu ? 'largeTablet' : 'tablet',
        end: 'desktop',
        styles: css`
          width: calc(50% - (32px / 2));
          &:nth-child(2n + 1) {
            margin-left: 0;
          }
          &:nth-child(2n + 2) {
            margin-right: 0;
          }
        `,
      })}
  }

  @media (min-width: ${breakpoints.desktop}px) {
    width: calc((100% / 3) - 16px);
  }

  @media (min-width: ${breakpoints.superWideDesktop}px) {
    width: calc((100% / 4) - 16px);
  }
`

export const HeaderContainer = styled.h2<{ $isVisible?: boolean }>`
  font-size: 17px;
  font-weight: 700;
  margin: 16px 24px 0px 16px;
  display: flex;
  align-items: flex-end;

  opacity: ${({ $isVisible = true }) => ($isVisible ? 1 : 0)};
  transition: all 0.3s ease-in-out;

  @media (min-width: ${breakpoints.tablet}px) {
    margin: 0px 0px 6px 32px;
    padding-top: 32px;
    font-size: 24px;
  }
`

export const FulfilmentCapsuleWrapper = styled.div`
  position: sticky;
  top: 124px;
  z-index: 10;
  padding: 12px 6px 4px 6px;
  scroll-margin-top: 64px;

  @media (min-width: ${breakpoints.tablet}px) {
    padding: 24px 6px 0px 6px;
  }
`

export const OutletsOuterContainer = styled.div<{ showAppBanner: boolean }>`
  width: 100%;
  padding-top: ${({ showAppBanner }) => (showAppBanner ? '184px' : '124px')};

  @media (min-width: ${breakpoints.largeTablet}px) {
    padding-top: 144px;
  }
`

export const OutletSkeletonWrapper = styled.div<{ $margin?: boolean }>`
  ${({ $margin }) => ($margin ? 'margin-top: 130px' : '')};
  animation: ${fadeIn} 0.3s ease-in-out;
`

export const NoneFound = styled.div`
  margin: 0 auto;
  margin-top: 24px;
  text-align: center;
  animation: ${fadeIn} 0.3s ease-in-out;
`
